import React, { useState } from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import { FormControl, Select, MenuItem } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import Icon from 'src/components/Icon/Icon';
import { Customer } from 'src/interfaces/AuthState';
import useIsMobile from 'src/hooks/useIsMobile';
import Button from 'src/components/Button/Button';

interface WalletSelectionProps {
  activeWallet:any,
  customer: Customer
  className?: string,
  changeSelectedWallet: Function
}

function WalletSelection({ activeWallet, customer, className, changeSelectedWallet }: WalletSelectionProps) {
  const [selectOpen, setSelectOpen] = useState(false);

  const dispatch = useDispatch();
  const mobile = useIsMobile();

  if (mobile){
    return (
      <FormControl className={ `deposit-funds__wallet ${ className }__wallet` }>
        <Select
          name="wallet"
          className="deposit-funds__wallet-selection"
          open= { selectOpen }
          disableUnderline
          MenuProps={
            {
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center'
              },
              getContentAnchorEl: null
            }
          }
          IconComponent={
            () => <Icon
              icon="dropdownArrow"
              onClick={ () => setSelectOpen(!selectOpen) }
              className={
                classNames({
                  'deposit-funds__dropdown-icon': true,
                  'deposit-funds__dropdown-icon--open': selectOpen
                })
              }
            />
          }
          value={ activeWallet.type }
          onOpen={ () => setSelectOpen(true) }
          onClose= { () => setSelectOpen(false)  }
          onChange={ (e) => dispatch.auth.selectWallet(e.target.value) }
        >
          {
            _.map(customer.wallets, (wallet, index) => <MenuItem
              key={ index }
              value={ wallet.type }
              className="deposit-funds__item"
            >
              { `${ wallet.type['name'] } wallet: ${ wallet.balance / wallet.divisor } ${ wallet.currency }` }</MenuItem>)
          }
        </Select>
      </FormControl>
    );
  } else {
    return (
      <div className="deposit-funds__wallet">
        {
          _.map(customer.wallets, (wallet, index) => {
            return (
              <Button
                key={ index }
                className={
                  classNames({
                    'deposit-funds__wallet-button': true,
                    'deposit-funds__wallet-button--selected': wallet.typeCode === activeWallet.typeCode
                  })
                }
                text={ ` ${ wallet.type['name'] } Wallet: ${ (wallet.balance / wallet.divisor).toFixed(2) } ${ wallet.currency }` }
                value={ wallet.type }
                onClick={ () => changeSelectedWallet(wallet) }
              />
            );
          })
        }
      </div>
    );
  }

}

export default WalletSelection;
